import { TemplatesDto } from '../../charging-sessions/api/dto/pdf-template.dto'
import { TemplateCategory } from '../../charging-sessions/api/dto/pdf-template-category.dto'

export const MOCK_EXPORT_TEMPLATES: TemplatesDto[] = [
  {
    templateCategory: TemplateCategory.CDR_E3DC_PDF,
    templateLocales: ['en', 'de', 'nl'],
  },
]
